module.exports = __webpack_public_path__ + "static/media/luggers-moving-junk_2x.a46a246e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/luggers-moving-junk_2x.png
// module id = 1206
// module chunks = 27